import { useQuery } from '@apollo/client';
import { Context } from './Context';
import { EditorDraftDocument } from './query.gql';
import { useUpdateDraft } from '../useUpdateDraft';
export function EditorDraftProvider(props) {
    const { children, draftId, currentRef } = props;
    const { updateDraft, loading: mutationLoading, error: mutationError } = useUpdateDraft();
    const { data, loading: queryLoading, error: queryError, updateQuery, } = useQuery(EditorDraftDocument, {
        variables: { id: draftId },
    });
    const loading = queryLoading;
    const isSaving = () => mutationLoading || updateDraft.isPending();
    const error = Boolean(queryError);
    const saveError = Boolean(mutationError);
    const value = { data, currentRef, loading, isSaving, error, saveError, updateQuery, updateDraft };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
